import * as React from "react";
import { FC } from "react";
import { Edit, EditProps } from "react-admin";
import SourceEditForm from "./Forms/SourceEditForm";
import { TitleQuarantine } from "./Constant/Source";

const QuarantineEdit: FC<EditProps> = props => {
  return (
    <Edit {...props} title={TitleQuarantine.edit} component="div">
      <SourceEditForm {...props} />
    </Edit>
  );
};

export default QuarantineEdit;
